import { render, staticRenderFns } from "./PageCont.vue?vue&type=template&id=7683c4f7&"
import script from "./PageCont.vue?vue&type=script&lang=js&"
export * from "./PageCont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports